import GraphQLJSON from 'graphql-type-json';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const handleGetRetailerDetails = () => {
  return {
    dialCode: '91',
    email: 'test@mobisy.com',
    id: '200',
    name: 'Test User',
    phoneno: '9876543210',
    retailerPreferences: {
      language: 'hi',
    },
    status: 'ACTIVE',
    unreadNotificationCount: Math.floor(Math.random() * 11),
    whatsappNo: '',
    isPhotoProvided: true,
  };
};

const handleUpdateRetailerDetails = input => {
  return {
    dialCode: input.dialCode,
    email: input.email,
    id: '200',
    name: input.name,
    phoneno: input.phoneno,
    retailerPreferences: {
      language: 'hi',
    },
    retailerCommunicationConsent: [
      {
        preferenceId: 1,
        response: 1,
      },
      {
        preferenceId: 2,
        response: 0,
      },
    ],
    status: 'ACTIVE',
    unreadNotificationCount: Math.floor(Math.random() * 11),
    whatsappNo: input.whatsappNo,
    isPhotoProvided: true,
  };
};

const mocks = {
  Query: {
    retailer: _ => handleGetRetailerDetails(),
  },
  Mutation: {
    updateRetailerDetails: (_, { input }) => handleUpdateRetailerDetails(input),
  },
};
export { resolvers, typeResolvers, mocks };
